/** 指令发送接口
 */
const instructSendCtl = {
  /** 无线升级指令下发
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  wirelessUpgrade: function (_this, url, instructList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: instructList,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '指令发送成功！',
          type: 'success'
        })
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    }).catch(err => {
      console.log(err)
    })
  },
  /** 睡眠指令下发
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  sleepSend: function (_this, url, instructList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: instructList,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '指令发送成功！',
          type: 'success'
        })
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    }).catch(err => {
      console.log(err)
    })
  },
  /** 睡眠指令下发
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  flashLED: function (_this, url, instructList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: instructList,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '指令发送成功！',
          type: 'success'
        })
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    }).catch(err => {
      console.log(err)
    })
  },
  /**  位置信息汇报指令下发
   * @param _this {object} 页面指针
   * @param url {string} 接口地址
   */
  reportLocation: function (_this, url, instructList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: instructList,
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (res) {
      if (res.data.code === 200) {
        _this.$message({
          message: '指令发送成功！',
          type: 'success'
        })
      } else {
        _this.$message({
          message: res.data.message,
          type: 'warning'
        })
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export default instructSendCtl



// WEBPACK FOOTER //
// ./src/javascript/function/instructSendFunction.js